<div class="thanks-modal">
    <ng-container *ngIf="data?.success">
        <h3>
            Hey,Congratulations you will receive your hard copy material on
         </h3>
           <h2>{{data?.data?.delivery_date | date: 'dd MMMM yyyy'}}</h2>
             <div class="check-cat-div">
                <div class="d-flex min-check-cat-div">
                    <div class="founder-img">
                        <img src="https://media.iquanta.in/ui_images/1instructor.jpeg">
                    </div>
                    <div class="content-div">
                        <h6 (click)="close()" [routerLink]="'/cat-2025'">
                            Check Cat 2024 Master Plan
                        </h6>
                    </div>
                </div>
               
             </div>
    </ng-container>
    <ng-container *ngIf="!data?.success">
        <h3>
            Hey,Congratulations you will receive your hard copy material on
         </h3>
           <h2>{{data?.useraddress?.delivery_date | date: 'dd MMMM yyyy'}}</h2>
           <div class="error-msg">
            You have not purchased hard copy yet buy now get it soon...
           </div>
             <div class="btn-div">
               <button mat-button (click)="buynow()">Buy Now</button>
             </div>
    </ng-container>

</div>

<div class="drone-img">
    <img src="https://media.iquanta.in/ui_images/new-dashboard/Drone.png" alt="">
</div>